import { render, staticRenderFns } from "./PeerStatus.vue?vue&type=template&id=bd439cdc&"
import script from "./PeerStatus.vue?vue&type=script&lang=js&"
export * from "./PeerStatus.vue?vue&type=script&lang=js&"
import style0 from "./PeerStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports